export var OPERATOR_EQUALS = '=';
export var OPERATOR_NOT_EQUALS = '!=';
export var OPERATOR_GT = '>';
export var OPERATOR_LT = '<';
export var OPERATOR_GT_EQUALS = '>=';
export var OPERATOR_LT_EQUALS = '<=';
export var OPERATOR_IN = 'in';
export var OPERATOR_NOT_IN = 'not in';
export var OPERATOR_LIKE = '~';
export var OPERATOR_NOT_LIKE = '!~';
export var OPERATOR_IS = 'is';
export var OPERATOR_IS_NOT = 'is not';
export var OPERATOR_WAS = 'was';
export var OPERATOR_WAS_IN = 'was in';
export var OPERATOR_WAS_NOT_IN = 'was not in';
export var OPERATOR_WAS_NOT = 'was not';
export var OPERATOR_CHANGED = 'changed'; // Operator groups

export var EQUALS_OPERATORS = [OPERATOR_EQUALS, OPERATOR_NOT_EQUALS];
export var LIKE_OPERATORS = [OPERATOR_LIKE, OPERATOR_NOT_LIKE];
export var COMPARISON_OPERATORS = [OPERATOR_LT, OPERATOR_GT, OPERATOR_LT_EQUALS, OPERATOR_GT_EQUALS];
export var IN_OPERATORS = [OPERATOR_IN, OPERATOR_NOT_IN];
export var IS_OPERATORS = [OPERATOR_IS, OPERATOR_IS_NOT];
export var WAS_OPERATORS = [OPERATOR_WAS, OPERATOR_WAS_NOT];
export var WAS_IN_OPERATORS = [OPERATOR_WAS_IN, OPERATOR_WAS_NOT_IN];
export var CHANGED_OPERATORS = [OPERATOR_CHANGED];
export var OPERATORS = [].concat(EQUALS_OPERATORS, LIKE_OPERATORS, COMPARISON_OPERATORS, IN_OPERATORS, IS_OPERATORS, WAS_OPERATORS, WAS_IN_OPERATORS, CHANGED_OPERATORS);
export var LIST_OPERATORS = [OPERATOR_IN, OPERATOR_NOT_IN, OPERATOR_WAS_IN, OPERATOR_WAS_NOT_IN];